export const style = {
    calendar: {},
    dateTimePicker: {
        textTransform: 'capitalize'
    },
    eventHeader: {
        color: '#e9ebec',
        paddingLeft: '0px',
        position: 'relative',
        top: '-15px',
        left: '25px',
        fontStyle: 'italic',
    },
    timePickerStart: {
        float: 'left',
        width: '48%',
    },
    timePickerEnd: {
        float: 'left',
        width: '48%',
        marginLeft: '4%'
    },
    userAssign: {
        float: 'left',
        width: '48%',
        textAlign: 'left',
        marginLeft: '4%'
    },
    issue: {
        float: 'left',
        width: '48%',
        textAlign: 'left',
    },
    timePickerTextFeid: {
        width: '100%'
    },
    statusStep: {
        width: '100%',
        float: 'left'
    },
    submitEvent: {
        float: 'right',
    },
    deleteEvent: {
        float: 'right',
        marginRight: '18px',
    },
    textFeid: {
        textAlign: 'left',
    },
    issues: {
        backgroundColor: '#fff',
        border: '1px solid #43A047',
        display: 'block',
        height: 'initial',
        padding: '0px',
        minWidth: '45px',
        boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
    },
    textTooltip: {
        wordWrap: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    },
    containTootip: {
        boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
        backgroundColor: 'white',
        padding: '4px',
        maxWidth: '400px',
        margin: '0'
    },
    iconForTootip: {
        top: '7px',
        paddingRight: '10px',
        paddingLeft: '5px',
    }
}  


// WEBPACK FOOTER //
// ./src/components/schedule/style.js